// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6183":"644e16dcd9a122d4","9577":"81deda5dfaf2c5b1"}[chunkId] + ".css";
};